export const LOADING_TRAINING = "LOADING_TRAINING";
export const SAVE_LOADING_TRAINING = "SAVE_LOADING_TRAINING";
export const GET_TRAINING = "GET_TRAINING";
export const FORM_FAIL_TRAINING = "FORM_FAIL_TRAINING";
export const TRAINING_FAIL = "TRAINING_FAIL";
export const LOADING_TRAINING_BY_ID = "LOADING_TRAINING_BY_ID";
export const GET_TRAINING_BY_ID = "GET_TRAINING_BY_ID";
export const SAVE_LOADING_TRAINING_BY_ID = "SAVE_LOADING_TRAINING_BY_ID";
